export class Campaign{

  constructor(public idCampania: number, public nombre: string, public descripcion: string, public imagen: string, public imagenMovil: string, public imagenTablet: string,
             public fechaInicio: Date, public fechaFin: Date, public utmParametros: string, public status: number) {}

}
